import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSearchMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M21.71 20.29 18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39M11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7m4-8H7a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2" />
  </svg>
);
export default SvgSearchMinus;
